import { styled } from "@mui/material/styles";
import { Avatar, Box, Typography, alpha, Chip, IconButton } from "@mui/material";
import theme, { palette } from "src/config/theme";

export const CardContainer = styled(Box)({
    width: '300px',
    height: '445px',
    borderRadius: '12px',
    border: `1px solid ${theme.palette.primary.light1}`,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.gery.white,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    // gap: '15px',
    padding: '10px 0',
    justifyContent: 'space-around',
    [theme.breakpoints.down('md')]: {
        width: '100%',
        height: '201px',
        alignItems: 'center'
    },
})
export const PatientCardContainer = styled(Box)({

    width: '100%',
    height: '180px',
    borderRadius: '12px',
    border: `1px solid ${theme.palette.primary.light1}`,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.gery.white,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    // gap: '15px',
    padding: '10px 0',
    justifyContent: 'space-around',
    [theme.breakpoints.down('md')]: {
        height: '160px',
    }
})
export const TaskCardContainer = styled(Box)({
    width: '100%',
    height: '300px',
    borderRadius: '12px',
    border: `1px solid ${theme.palette.primary.light1}`,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.gery.white,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    // gap: '15px',
    padding: '10px 0',
    justifyContent: 'space-around',
    [theme.breakpoints.down('md')]: {
        width: '100%',
    }
})
export const CardHeader = styled(Box)({
    width: '100%',
    height: '82px',
    // backgroundColor: theme.palette.primary.light4,
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    padding: '20px',
    [theme.breakpoints.down('md')]: {
        width: '100%',
        height: '41px',
        justifyContent: 'space-between',
        padding: '0 16px',
        gap: 0,

    },
})
export const ProfileContainer = styled(Avatar)({
    width: '64px',
    height: '64px',
    padding: '8px',
    borderRadius: '35px',
    backgroundColor: theme.palette.primary.light4,
    ...theme.typography.h2, // Changed from h1
    color: theme.palette.primary.main,
    [theme.breakpoints.down('md')]: {
        width: '48px',
        height: '48px',
        padding: '8px',
        ...theme.mobileTypography.h3,
    },
})
export const InnerContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // height: '46px',
    gap: '4px',
    overflow: 'hidden'
})
export const Title = styled(Typography)({
    ...theme.typography.h5,
    fontWeight: 600,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.h5,
    },
})

export const Year_Gender = styled(Box)({
    display: 'flex',
    gap: '6px',
    width: '100%', // Changed from auto to 100% to ensure it uses available width
    flexWrap: 'nowrap',
    alignItems: 'center',
})
export const Title2 = styled(Typography)({
    fontSize: '12px', // Smaller font for detail
    lineHeight: '16px',
    color: `${alpha(theme.palette.gery.black, 0.7)}`,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.body2,
    },
})
export const Dot = styled(Box)({
    width: '5px',
    height: '5px',
    borderRadius: '50%',
    backgroundColor: theme.palette.gery.lightGray
})
export const Line = styled(Box)({
    width: '100%',
    border: `1px solid ${alpha(theme.palette.gery.black, 0.102)}`,
    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
})

export const InnerContainer2 = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 20px',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
        padding: 0,
    },
})
export const Title3 = styled(Typography)({
    ...theme.typography.body1,
    color: `${alpha(theme.palette.gery.black, 0.7)}`
})
export const SymptomsContainer = styled(Box)({
    width: 'auto',
    height: '112px',
    borderRadius: '12px',
    backgroundColor: theme.palette.primary.light4,
    margin: '0px 5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
})

export const SymptomsText = styled(Typography)({
    ...theme.typography.body1,
    color: `${alpha(theme.palette.gery.black, 0.70)}`,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.h6,
        color: theme.palette.gery.black,
    },

})

export const CheapContainer = styled(Chip)({
    background: "linear-gradient(0deg, rgba(150, 57, 150, 0.12), rgba(150, 57, 150, 0.12))",
    color: theme.palette.action.purpleDark,
    ...theme.typography.small,
    borderRadius: '100px',
    // padding: '10px 18px 8px 18px',
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.body1,
    },

})

export const MenuContainer = styled(IconButton)(({ theme, isActive }) => ({
    width: '40px',
    height: '40px',
    borderRadius: '100px',
    color: theme.palette.primary.main,
    backgroundColor: isActive ? theme.palette.primary.main : theme.palette.primary.light4,
    color: isActive ? theme.palette.gery.white : theme.palette.primary.main,
    transition: "background-color 0.3s ease-in-out",
}));
export const AvatarIcon = styled(Avatar)({
    width: '64px',
    height: '64px',
    padding: '10px',
    borderRadius: '40px',
    background: 'linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18)), #FFFFFF',
    marginBottom: '5px'
})
export const RoleContainer = styled(Chip)({
    background: `linear-gradient(0deg, rgba(103, 57, 150, 0.14), rgba(103, 57, 150, 0.14))`,
    color: theme.palette.action.purpleDark,
    ...theme.typography.small,
    borderRadius: '100px',
    padding: '10px',
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.body1,
    },
})

export const AssignedContainer = styled(Box)({
    width: 'auto',
    height: '200px',
    borderRadius: '12px',
    backgroundColor: theme.palette.primary.light4,
    margin: '5px 5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
})

export const HeaderPart = styled(Box)({
    backgroundColor: theme.palette.primary.light3,
    color: theme.palette.gery.black,
    ...theme.typography.h3,
    borderBottom: `1px solid ${theme.palette.primary.light1} !important`,
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '64px',
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.h4,
    }
})
export const PagingContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '50px',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    borderRadius: '0px 0px 6px 6px',
    border: `1px solid ${palette.primary.light2}`,
    backgroundColor: palette.gery.white,
})
export const Container2 = styled(Box)({
    height: 'calc(100vh - 80px)',
    overflow: 'hidden',
    width: '100%',
    // marginTop: '20px',
    marginBottom: '50px',
    display: 'flex',
    flexDirection: 'column',
});
export const InnerAppointments = styled(Box)({
    flex: 1,
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    justifyContent: 'space-between',
    scrollbarWidth: 'none', // Firefox
    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: alpha(palette.primary.main, 0.5),
        borderRadius: '8px',
    },

});
export const InnerBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isEmpty'
})(({ isEmpty }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: isEmpty ? '0px' : '16px',
    justifyContent: isEmpty ? 'center' : 'flex-start',
    alignItems: isEmpty ? 'center' : 'center',
    height: isEmpty ? '100%' : 'auto',
    [theme.breakpoints.up('sm')]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
    },
    [theme.breakpoints.up('md')]: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '20px',
    },
}));

export const Text1 = styled(Typography)({
    ...theme.typography.h5,
    color: theme.palette.gery.black,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.h5
    }
})
export const Text2 = styled(Typography)({
    ...theme.typography.smallRegular,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.smallRegular
    }
})